import 'react-tooltip/dist/react-tooltip.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/consignmentcreation.css';
import { useNavigate } from "react-router-dom";
import { useState, useEffect, useContext, useRef, useMemo } from "react";
import LoggedInContainer from '../../layout/LoggedInContainer';
import { Container, Row, Col, Form, InputGroup, Stack, Button, Alert, Spinner } from "react-bootstrap";
import ConsignmentProgression from "../../components/ConsignmentCreation/ConsignmentProgression";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus, faXmark, faSquare } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "react-tooltip";
import { getDeparturePorts, getDestinationPorts, getVessels, getVoyageConsignmentAlreadyExistsWithLNCNumber } from '../../api/apiAccess';
import DateTimePicker from '../../components/DateTimePicker';
import { addToOrUpdateSessionConsignmentBeingCreated, clearSessionConsignmentBeingCreated, getSessionConsignmentBeingCreated } from '../../helpers/SessionHelper';
import { UserContext } from '../..';
import { FeedNumberValidationRules, parseNumericInput } from "../../utils/InputValidator";
import { formatUpToSpecifiedPrecision } from '../../utils/common';
import { UserType } from "../../api/enums/EnumUserType";
import PortStopFeedLoading from '../../components/ConsignmentCreation/PortStopFeedLoading';
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

const Consignment_VoyageDetails = () => {
    const navigate = useNavigate();
    const userCtx = useContext(UserContext);
    const inputFormContainer = useRef();
    const [existingConsignment, setExistingConsignment] = useState(null);
    const [lncNumber, setLNCNumber] = useState("");
    const [hasUnexpectedErrorCheckingLNC, setHasUnexpectedErrorCheckingLNC] = useState("");
    const [isBusy, setIsBusy] = useState(false);
    const [departurePorts, setDeparturePorts] = useState([]);
    const [destinationPorts, setDestinationPorts] = useState([]);
    const [selectedDeparturePort, setSelectedDeparturePort] = useState({});
    const [selectedFeedOnlyLoadPorts, setSelectedFeedOnlyLoadPorts] = useState([]);
    const [selectedDestinationPort, setSelectedDestinationPort] = useState({});
    const [selectedDestinationPortStops, setSelectedDestinationPortsStops] = useState([]);
    const [vessels, setVessels] = useState([]);
    const [vesselID, setVesselID] = useState(1);
    const [robPellets, setROBPellets] = useState(0);
    const [robGrain, setROBGrain] = useState(0);
    const [robRoughage, setROBRoughage] = useState(0);
    const [departureLoadingPellets, setDepartureLoadingPellets] = useState(0);
    const [departureLoadingGrain, setDepartureLoadingGrain] = useState(0);
    const [departureLoadingRoughage, setDepartureLoadingRoughage] = useState(0);
    const [estimatedDepartureDateTime, setEstimatedDepartureDateTime] = useState(null);
    const [estimatedArrivalDateTime, setEstimatedArrivalDateTime] = useState(null);
    const [canAddDischargePort, setCanAddDischargePort] = useState(true);
    const [isLNCNumberValid, setIsLNCNumberValid] = useState(true);
    const [LNCNumberErrorMessage, setLNCNumberErrorMessage] = useState("");
    const [isEstimatedDepartureDateTimeValid, setIsEstimatedDepartureDateTimeValid] = useState(true);
    const [isEstimatedArrivalDateTimeValid, setIsEstimatedArrivalDateTimeValid] = useState(true);
    const [estimatedArrivalErrorMessages, setEstimatedArrivalErrorMessages] = useState([]);
    const [estimatedDepartureErrorMessages, setEstimatedDepartureErrorMessages] = useState([]);
    const [isUseAlternatePenSpacing, setIsUseAlternatePenSpacing] = useState(false);
    const [isFeedPerDeckEnabled, setIsFeedPerDeckEnabled] = useState(false);
    const [isMultiPortLoad, setIsMultiPortLoad] = useState(false);

    // Feed validity
    const [robPelletsValid, setROBPelletsValid] = useState(true);
    const [robGrainValid, setROBGrainValid] = useState(true);
    const [robRoughageValid, setROBRoughageValid] = useState(true);

    const [loadedPelletsValid, setLoadedPelletsValid] = useState(true);
    const [loadedGrainValid, setLoadedGrainValid] = useState(true);
    const [loadedRoughageValid, setLoadedRoughageValid] = useState(true);

    //#region Utility variables
    const progressStages = [
        { title: "Voyage Details", completed: false },
        { title: "Personnel & Reporting", completed: false },
        { title: "Livestock", completed: false },
        { title: "Approved Management Plans", completed: false }
    ];
    //#endregion

    //#region Initial page setup functions
    useEffect(() => {
        const fetchAll = async () => {
            const [departureRes, destinationRes, vesselsRes] = await Promise.all([
                getDeparturePorts(),
                getDestinationPorts(),
                getVessels()
            ]);

            if (departureRes?.status === 200) {
                setDeparturePorts(departureRes.data);
            }

            if (destinationRes?.status === 200) {
                setDestinationPorts(destinationRes.data);
            }

            if (vesselsRes?.status === 200) {
                setVessels(vesselsRes.data);
            }
        };

        fetchAll();
    }, []);

    useEffect(() => {
        if (!departurePorts.length || !destinationPorts.length) return;

        const sessionConsignmentBeingCreated = getSessionConsignmentBeingCreated();

        if (sessionConsignmentBeingCreated) {
            setExistingConsignment(sessionConsignmentBeingCreated);
            setIsUseAlternatePenSpacing(sessionConsignmentBeingCreated.isUseAlternatePenSpacing);
            setIsFeedPerDeckEnabled(sessionConsignmentBeingCreated.isFeedPerDeckEnabled);
            setIsMultiPortLoad(sessionConsignmentBeingCreated.isMultiPortLoad);

            setLNCNumber(sessionConsignmentBeingCreated.lncNumber > 0 ? sessionConsignmentBeingCreated.lncNumber.toString() : "")
            setEstimatedDepartureDateTime(sessionConsignmentBeingCreated.estimatedDepartureDateTime ? new Date(sessionConsignmentBeingCreated.estimatedDepartureDateTime) : null);
            setEstimatedArrivalDateTime(sessionConsignmentBeingCreated.estimatedArrivalDateTime ? new Date(sessionConsignmentBeingCreated.estimatedArrivalDateTime) : null);
            setSelectedDeparturePort(sessionConsignmentBeingCreated.departurePort ? sessionConsignmentBeingCreated.departurePort : departurePorts[0])
            setSelectedDestinationPort(sessionConsignmentBeingCreated.finalDestinationPort ? sessionConsignmentBeingCreated.finalDestinationPort : destinationPorts[0])
            setSelectedDestinationPortsStops(sessionConsignmentBeingCreated.destinationPortStops ?? []);
            setSelectedFeedOnlyLoadPorts(sessionConsignmentBeingCreated.feedOnlyLoadPorts ?? []);
            setVesselID(sessionConsignmentBeingCreated.vesselID > 0 ? sessionConsignmentBeingCreated.vesselID : 1);
            setROBPellets(sessionConsignmentBeingCreated.robPellets > -1 ? sessionConsignmentBeingCreated.robPellets : 0);
            setROBGrain(sessionConsignmentBeingCreated.robGrain > -1 ? sessionConsignmentBeingCreated.robGrain : 0);
            setROBRoughage(sessionConsignmentBeingCreated.robRoughage > -1 ? sessionConsignmentBeingCreated.robRoughage : 0);
            setDepartureLoadingPellets(sessionConsignmentBeingCreated.departureLoadingPellets > -1 ? sessionConsignmentBeingCreated.departureLoadingPellets : 0);
            setDepartureLoadingGrain(sessionConsignmentBeingCreated.departureLoadingGrain > -1 ? sessionConsignmentBeingCreated.departureLoadingGrain : 0);
            setDepartureLoadingRoughage(sessionConsignmentBeingCreated.departureLoadingRoughage > -1 ? sessionConsignmentBeingCreated.departureLoadingRoughage : 0);
        } else {
            setSelectedDeparturePort(departurePorts[0]);
            setSelectedDestinationPort(destinationPorts[0]);
            setIsFeedPerDeckEnabled(userCtx.associatedExporter?.exporter?.feedPerDeckDefault);
        }
    }, [departurePorts, destinationPorts]);

    useEffect(() => {
        setVessels(vessels);
    }, [vessels])

    useEffect(() => {
        setCanAddDischargePort(selectedDestinationPortStops.length < 5)
    }, [selectedDestinationPortStops]);

    const parseFeedInput = (input) => {
        let amount = parseFloat(Number(input));
        if (isNaN(amount)) {
            amount = 0;
        }
        return amount;
    };

    const totalPellets = useMemo(() => {
        let total = 0;
        total += parseFeedInput(robPellets);
        total += parseFeedInput(departureLoadingPellets);
        selectedFeedOnlyLoadPorts?.forEach(port => {
            total += parseFeedInput(port.feedPlan?.pellets);
        });
        return total;
    }, [robPellets, departureLoadingPellets, selectedFeedOnlyLoadPorts]);

    const totalGrain = useMemo(() => {
        let total = 0;
        total += parseFeedInput(robGrain);
        total += parseFeedInput(departureLoadingGrain);
        selectedFeedOnlyLoadPorts?.forEach(port => {
            total += parseFeedInput(port.feedPlan?.grain);
        });
        return total;
    }, [robGrain, departureLoadingGrain, selectedFeedOnlyLoadPorts]);

    const totalRoughage = useMemo(() => {
        let total = 0;
        total += parseFeedInput(robRoughage);
        total += parseFeedInput(departureLoadingRoughage);
        selectedFeedOnlyLoadPorts?.forEach(port => {
            total += parseFeedInput(port.feedPlan?.roughage);
        });
        return total;
    }, [robRoughage, departureLoadingRoughage, selectedFeedOnlyLoadPorts]);

    const totalFeed = useMemo(() => {
        return totalPellets + totalGrain + totalRoughage;
    }, [totalPellets, totalGrain, totalRoughage]);

    const goToPersonnel = async () => {
        setIsBusy(true);
        if (await validateInputData()) {
            updateConsignmentBeingCreated();
            setIsBusy(false);
            navigate("/createconsignmentpersonnel");
        } else {
            window.scrollTo(0, inputFormContainer.current.offsetTop);
            setIsBusy(false);
        }
    };

    const goToDashboard = () => {
        clearSessionConsignmentBeingCreated();
        navigate("/dashboard");
    };

    const addFeedOnlyConsignmentPort = () => {
        setSelectedFeedOnlyLoadPorts(prev => [
            ...prev,
            {
                ...departurePorts[0], isFeedOnly: true,
                feedPlan: {
                    pellets: 0,
                    pelletsValid: true,
                    grain: 0,
                    grainValid: true,
                    roughage: 0,
                    roughageValid: true
                }
            }
        ]);
    };

    const updateFeedOnlyConsignmentPort = (selectedPort, index) => {
        setSelectedFeedOnlyLoadPorts(prev => {
            const updated = [...prev];
            updated[index] = { ...updated[index], ...selectedPort };
            return updated;
        });
    };

    const removeFeedOnlyConsignmentPort = (index) => {
        setSelectedFeedOnlyLoadPorts(prev =>
            prev.filter((_, i) => i !== index)
        );
    };

    const updateFeedOnlyConsignmentPortTiming = (index, feedLoadedPriorToDeparture) => {
        setSelectedFeedOnlyLoadPorts(prev => {
            const updated = [...prev];
            updated[index] = { ...updated[index], feedLoadedPriorToDeparture: feedLoadedPriorToDeparture };
            return updated;
        });
    };

    const updateFeedOnlyConsignmentPortFeed = (index, type, amount) => {

        setSelectedFeedOnlyLoadPorts(prev => {
            const updated = [...prev];

            const currentFeedPlan = updated[index].feedPlan || {};

            updated[index] = {
                ...updated[index],
                feedPlan: {
                    ...currentFeedPlan,
                    [type]: amount,
                    [`${type}Valid`]: true
                },
            };

            return updated;
        });
    };

    const updateFeedOnlyConsignmentPortFeedIsValid = (index, type, isValid) => {
        setSelectedFeedOnlyLoadPorts(prev => {
            const updated = [...prev];

            const currentFeedPlan = updated[index].feedPlan || {};

            updated[index] = {
                ...updated[index],
                feedPlan: {
                    ...currentFeedPlan,
                    [`${type}Valid`]: isValid
                },
            };

            return updated;
        });
    };

    const updateConsignmentPortLoadedFeed = (type, amount) => {
        if (type === "pellets") {
            setDepartureLoadingPellets(amount);
            setLoadedPelletsValid(true);
        } else if (type === "grain") {
            setDepartureLoadingGrain(amount);
            setLoadedGrainValid(true);
        } else if (type === "roughage") {
            setDepartureLoadingRoughage(amount);
            setLoadedRoughageValid(true);
        }
    };

    const updateConsignmentFeedROB = (type, amount) => {
        if (type === "pellets") {
            setROBPellets(amount);
            setROBPelletsValid(true);
        } else if (type === "grain") {
            setROBGrain(amount);
            setROBGrainValid(true);
        } else if (type === "roughage") {
            setROBRoughage(amount);
            setROBRoughageValid(true);
        }
    };

    const addStopConsignmentPort = () => {
        setSelectedDestinationPortsStops(prev => [
            ...prev,
            { ...destinationPorts[0] }
        ]);
    };

    const updateStopConsignmentPort = (selectedPort, stopIndex) => {
        setSelectedDestinationPortsStops(prev => {
            const updated = [...prev];
            updated[stopIndex] = { ...updated[stopIndex], ...selectedPort };
            return updated;
        });
    };

    const removeStopConsignmentPort = (stopIndex) => {
        setSelectedDestinationPortsStops(prev =>
            prev.filter((_, i) => i !== stopIndex)
        );
    };

    const updateSelectedDeparturePort = (port) => {
        setSelectedDeparturePort(port);
    };

    const updateSelectedDestinationPort = (port) => {
        setSelectedDestinationPort(port);
    };
    //#endregion

    //#region Validation
    const validateInputData = async () => {
        let isAllValid = true;
        clearCurrentErrors();
        let lncExistsResponseSuccess = false;
        if (!lncNumber || lncNumber.length !== 6) {
            isAllValid = false;
            setIsLNCNumberValid(false);
            setLNCNumberErrorMessage("LNC number must be numeric and six digits long.");
        }
        else {
            const lncExistsResponse = await getVoyageConsignmentAlreadyExistsWithLNCNumber(lncNumber, existingConsignment?.id);
            lncExistsResponseSuccess = lncExistsResponse.status === 200;
            if (lncExistsResponseSuccess) {
                if (lncExistsResponse.data === true) {
                    setIsLNCNumberValid(false);
                    setLNCNumberErrorMessage("A consignment already exists with this LNC Number.");
                    isAllValid = false;
                }
                else {
                    setLNCNumberErrorMessage("")
                    setIsLNCNumberValid(true);
                }
            }
            else {
                setHasUnexpectedErrorCheckingLNC(true);
            }
        }

        if (!estimatedDepartureDateTime) {
            isAllValid = false;
            let tempErrors = [...estimatedDepartureErrorMessages];
            tempErrors.push("The estimated departure date and time must be provided.");
            setEstimatedDepartureErrorMessages(tempErrors);
            setIsEstimatedDepartureDateTimeValid(false);
        }

        if (!estimatedArrivalDateTime) {
            isAllValid = false;
            let tempErrors = [...estimatedArrivalErrorMessages];
            tempErrors.push("The estimated arrival date and time must be provided.");
            setEstimatedArrivalErrorMessages(tempErrors);
            setIsEstimatedArrivalDateTimeValid(false);
        }

        if (estimatedArrivalDateTime && estimatedDepartureDateTime && estimatedArrivalDateTime <= estimatedDepartureDateTime) {
            isAllValid = false;
            let tempDepartureErrors = [...estimatedDepartureErrorMessages];
            tempDepartureErrors.push("The departure date and time must be earlier than the arrival date and time.");
            setEstimatedDepartureErrorMessages(tempDepartureErrors);
            let tempArrivalErrors = [...estimatedArrivalErrorMessages];
            tempArrivalErrors.push("The arrival date and time must be later than the departure date and time.");
            setEstimatedArrivalErrorMessages(tempArrivalErrors);
            setIsEstimatedArrivalDateTimeValid(false);
            setIsEstimatedDepartureDateTimeValid(false);
        }

        // Validate feed
        let lROBPelletsValid = true;
        let lROBGrainValid = true;
        let lROBRoughageValid = true;
        let lLoadedPelletsValid = true;
        let lLoadedGrainValid = true;
        let lLoadedRoughageValid = true;

        if (robPellets && isNaN(robPellets) === true) {
            isAllValid = false;
            lROBPelletsValid = false;
        }
        if (robGrain && isNaN(robGrain) === true) {
            isAllValid = false;
            lROBGrainValid = false;
        }
        if (robRoughage && isNaN(robRoughage) === true) {
            isAllValid = false;
            lROBRoughageValid = false;
        }

        if (departureLoadingPellets && isNaN(departureLoadingPellets) === true) {
            isAllValid = false;
            lLoadedPelletsValid = false;
        }
        if (departureLoadingGrain && isNaN(departureLoadingGrain) === true) {
            isAllValid = false;
            lLoadedGrainValid = false;
        }
        if (departureLoadingRoughage && isNaN(departureLoadingRoughage) === true) {
            isAllValid = false;
            lLoadedRoughageValid = false;
        }

        setROBPelletsValid(lROBPelletsValid);
        setROBGrainValid(lROBGrainValid);
        setROBRoughageValid(lROBRoughageValid);
        setLoadedPelletsValid(lLoadedPelletsValid);
        setLoadedGrainValid(lLoadedGrainValid);
        setLoadedRoughageValid(lLoadedRoughageValid);

        selectedFeedOnlyLoadPorts?.forEach((port, index) => {
            const pelletsValid = !isNaN(port?.feedPlan?.pellets);
            const grainValid = !isNaN(port?.feedPlan?.grain);
            const roughageValid = !isNaN(port?.feedPlan?.roughage);

            updateFeedOnlyConsignmentPortFeedIsValid(index, "pellets", pelletsValid);
            updateFeedOnlyConsignmentPortFeedIsValid(index, "grain", grainValid);
            updateFeedOnlyConsignmentPortFeedIsValid(index, "roughage", roughageValid);

            if (!pelletsValid || !grainValid || !roughageValid) {
                isAllValid = false;
            }
        });

        // if lncExistsResponseSuccess is false we show a generic error message
        return isAllValid && lncExistsResponseSuccess;
    }

    const clearCurrentErrors = () => {
        setIsEstimatedArrivalDateTimeValid(true);
        setIsEstimatedDepartureDateTimeValid(true);
        setIsLNCNumberValid(true);
        setLNCNumberErrorMessage("");
        setHasUnexpectedErrorCheckingLNC(false);
        setEstimatedArrivalErrorMessages([]);
        setEstimatedDepartureErrorMessages([]);
    }
    //#endregion

    //#region Consignment Model
    const updateConsignmentBeingCreated = () => {
        let exporterID = userCtx.associatedExporter?.exporter?.id;
        if (exporterID === undefined) {
            // Fetch the logged in user's exporter id and update the associated exporter
            // Or log the user out?
        }

        addToOrUpdateSessionConsignmentBeingCreated({
            exporterID: exporterID,
            exporter: userCtx.associatedExporter.exporter,
            lncNumber: lncNumber,
            departurePort: selectedDeparturePort,
            feedOnlyLoadPorts: selectedFeedOnlyLoadPorts.map(stop => stop).filter(stop => stop?.id && stop?.countryID),
            finalDestinationPort: selectedDestinationPort,
            destinationPortStops: selectedDestinationPortStops.map(stop => stop).filter(stop => stop?.id && stop?.countryID),
            vesselID: vesselID,
            estimatedDepartureDateTime: estimatedDepartureDateTime,
            estimatedArrivalDateTime: estimatedArrivalDateTime,
            robPellets: robPellets,
            robGrain: robGrain,
            robRoughage: robRoughage,
            departureLoadingPellets: departureLoadingPellets,
            departureLoadingGrain: departureLoadingGrain,
            departureLoadingRoughage: departureLoadingRoughage,
            isUseAlternatePenSpacing: isUseAlternatePenSpacing,
            isFeedPerDeckEnabled: isFeedPerDeckEnabled,
            isMultiPortLoad: isMultiPortLoad
        })
    }
    //#endregion

    // Can only stop at each port once
    const isPortInvalid = (portID) => {
        const allPorts = [
            selectedDestinationPort,
            ...(selectedFeedOnlyLoadPorts ?? []),
            ...(selectedDestinationPortStops ?? []),
            selectedDeparturePort
        ].filter(Boolean);
        return allPorts.filter(cp => cp?.id === portID).length > 1;
    };

    return (
        <LoggedInContainer>
            <Container fluid className="p-0" style={{ backgroundColor: "#F5F5F5" }}>
                <Row className="upper-panel">
                    <Container>
                        <Row>
                            <Col xs={12}>
                                <div className="text-center heading-text mb-2 mt-3" style={{ color: "#FFF", lineHeight: "53px", fontSize: "35px" }}>Create new consignment</div>
                                <ConsignmentProgression stages={progressStages} currentStage={progressStages[0]} key="consignment_progress" />
                            </Col>
                        </Row>
                    </Container>
                </Row>
                <Row>
                    <Container ref={inputFormContainer} className="py-4 px-5 form-container">
                        <Row style={{ marginBottom: "40px" }}>
                            <Col xs={12}>
                                <Stack direction='horizontal' gap={2}>
                                    <FontAwesomeIcon icon={faSquare} style={{ fontSize: "24px" }} className='voluntary-data-text' />
                                    <span className="darkblue field-label">Denotes industry-only data that does not go to department.</span>
                                </Stack>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <div className="heading-text darkblue">Voyage details</div>
                                <div className="bg-override-primary mt-1 mb-3" style={{ height: "2px" }}></div>
                            </Col>
                        </Row>
                        <Row className="mb-4">
                            <Col xs={12} className="darkblue field-label mb-1">
                                LNC Number
                            </Col>
                            <Col xs={12}>
                                <Form.Group id="lnc-number-form-group">
                                    <InputGroup className="pb-3">
                                        <InputGroup.Text id="lnc-number">LNC-</InputGroup.Text>
                                        <Form.Control
                                            autoComplete='off'
                                            isInvalid={!isLNCNumberValid}
                                            id="lnc-number-input"
                                            aria-label="LNCNumber"
                                            aria-describedby="lnc-number"
                                            onChange={(e) => {
                                                setLNCNumber(e.target.value);
                                            }}
                                            value={lncNumber}
                                        />
                                        {!isLNCNumberValid ?
                                            (
                                                <div className="validation-error-tooltip">
                                                    <Tooltip
                                                        anchorSelect="#lnc-number-form-group"
                                                        place="top"
                                                        content={LNCNumberErrorMessage}
                                                    />
                                                </div>
                                            ) : null

                                        }
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mb-4">
                            <Col xs={12} className="darkblue field-label mb-1">
                                Departure Port
                            </Col>
                            <Col xs={12}>
                                <Form.Select
                                    aria-label="Departure Port"
                                    onChange={(e) => {
                                        let selectedPort = departurePorts.find(p => Number(p.id) === Number(e.target.value));
                                        updateSelectedDeparturePort(selectedPort);
                                    }}
                                    value={selectedDeparturePort?.id}
                                >
                                    {
                                        departurePorts && departurePorts.length > 0 && departurePorts.map((depPort, i) => {
                                            return (
                                                <option key={`departure_port_${i}_${depPort.name}`} value={depPort.id}>{`Australia - ${depPort.portName}`}</option>
                                            )
                                        })
                                    }
                                </Form.Select>
                            </Col>
                            {
                                <>
                                    {
                                        selectedFeedOnlyLoadPorts?.map((dp, stopIndex) => {
                                            // A port is invalid if it already exists in the list of consignment ports
                                            const stopIsInvalid = isPortInvalid(dp.id);
                                            const lNum = selectedFeedOnlyLoadPorts.indexOf(dp) + 1;
                                            return (
                                                <Row key={`dp_${stopIndex}`} className="mt-3">
                                                    <Col xs={12}>
                                                        <Row >
                                                            <Col xs={12} className="darkblue field-label mb-1">
                                                                Feed-only Load Port {lNum}
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col xs={6}>
                                                                <Form.Group>
                                                                    <InputGroup >
                                                                        <Form.Select
                                                                            isInvalid={stopIsInvalid}
                                                                            aria-label="PortStop"
                                                                            aria-describedby={`port-stop-${stopIndex}`}
                                                                            id={`port-stop-${stopIndex}`}
                                                                            onChange={(e) => {
                                                                                let selectedPort = departurePorts.find(p => Number(p.id) === Number(e.target.value));
                                                                                updateFeedOnlyConsignmentPort(selectedPort, stopIndex);
                                                                            }}
                                                                            value={dp?.id}
                                                                        >
                                                                            {departurePorts && departurePorts.map((depPort, i) => {
                                                                                return (
                                                                                    <option key={`stop_port_${stopIndex}_${i}_${depPort.portName}`} value={depPort?.id}>{`${depPort.countryName} - ${depPort.portName}`}</option>
                                                                                )
                                                                            })
                                                                            }
                                                                        </Form.Select>
                                                                        {
                                                                            !(existingConsignment && existingConsignment.isPostEOV) && (
                                                                                <Button onClick={(e) => { e.preventDefault(); removeFeedOnlyConsignmentPort(stopIndex); }}><FontAwesomeIcon icon={faXmark} /></Button>
                                                                            )
                                                                        }
                                                                    </InputGroup>
                                                                </Form.Group>

                                                                {
                                                                    stopIsInvalid ?
                                                                        (
                                                                            <div className="validation-error-tooltip">
                                                                                <Tooltip
                                                                                    anchorSelect={`#port-stop-${stopIndex}`}
                                                                                    variant="error"
                                                                                    content='The same port can not be added twice.'
                                                                                />
                                                                            </div>
                                                                        ) : null
                                                                }
                                                            </Col>
                                                            <Col xs={6} className='d-flex justify-content-end'>
                                                                <div style={{ paddingLeft: "20px" }}>
                                                                    <Form.Check
                                                                        type={`checkbox`}
                                                                        id={`chkFeedOnlyLoadTiming_${stopIndex}`}
                                                                        label={
                                                                            <>
                                                                                Feed loaded <u>before</u> livestock
                                                                            </>
                                                                        }
                                                                        checked={dp.feedLoadedPriorToDeparture}
                                                                        onChange={(e) => updateFeedOnlyConsignmentPortTiming(stopIndex, e.target.checked)}
                                                                        className="field-label secondary-grey"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            )
                                        })}
                                    <Col xs={12}>
                                        <div className='d-flex align-items-center mt-3 '>
                                            <Button onClick={(e) => { e.preventDefault(); addFeedOnlyConsignmentPort(); }} className="border-0 btn-secondary cc-add-port-button">
                                                <FontAwesomeIcon icon={faCirclePlus} className="primary-green" /> Add feed-only load port
                                            </Button>
                                            <FontAwesomeIcon className="info-icon" icon={faInfoCircle} title={"Select when feed is loaded specifically for this consignment at a different port to the livestock. This does not include feed remaining on board from a previous voyage.\nExample: feed loaded in Fremantle, cattle loaded in Portland."}></FontAwesomeIcon>
                                        </div>
                                    </Col>
                                </>
                            }
                        </Row>
                        {
                            selectedDestinationPortStops?.map((dp, stopIndex) => {
                                // A port is invalid if it already exists in the list of consignment ports
                                const stopIsInvalid = isPortInvalid(dp.id);
                                const lStopNum = selectedDestinationPortStops.indexOf(dp) + 1;
                                return (
                                    <Row key={`dp_${stopIndex}`} className="mb-3">
                                        <Col xs={12}>
                                            <Row >
                                                <Col xs={12} className="darkblue field-label mb-1">
                                                    Stop {lStopNum}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={12}>
                                                    <Form.Group>
                                                        <InputGroup >
                                                            <Form.Select
                                                                isInvalid={stopIsInvalid}
                                                                aria-label="PortStop"
                                                                aria-describedby={`port-stop-${stopIndex}`}
                                                                id={`port-stop-${stopIndex}`}
                                                                onChange={(e) => {
                                                                    let selectedPort = destinationPorts.find(p => Number(p.id) === Number(e.target.value));
                                                                    updateStopConsignmentPort(selectedPort, stopIndex);
                                                                }}
                                                                value={dp?.id}
                                                            >
                                                                {destinationPorts && destinationPorts.map((destPort, i) => {
                                                                    return (
                                                                        <option key={`stop_port_${stopIndex}_${i}_${destPort.portName}`} value={destPort?.id}>{`${destPort.countryName} - ${destPort.portName}`}</option>
                                                                    )
                                                                })
                                                                }
                                                            </Form.Select>
                                                            {
                                                                !(existingConsignment && existingConsignment.isPostEOV) && (
                                                                    <Button onClick={(e) => { e.preventDefault(); removeStopConsignmentPort(stopIndex); }}><FontAwesomeIcon icon={faXmark} /></Button>
                                                                )
                                                            }
                                                        </InputGroup>
                                                    </Form.Group>
                                                    {
                                                        stopIsInvalid ?
                                                            (
                                                                <div className="validation-error-tooltip">
                                                                    <Tooltip
                                                                        anchorSelect={`#port-stop-${stopIndex}`}
                                                                        variant="error"
                                                                        content='The same port can not be added twice.'
                                                                    />
                                                                </div>
                                                            ) : null
                                                    }
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                )
                            })}
                        <Row>
                            <Col xs={12} className="darkblue field-label mb-1">
                                Final Destination Port
                            </Col>
                            <Col xs={12}>
                                <Form.Select
                                    aria-label="Final Destination Port"
                                    onChange={(e) => {
                                        let selectedPort = destinationPorts.find(p => Number(p.id) === Number(e.target.value));
                                        updateSelectedDestinationPort(selectedPort);
                                    }}
                                    value={selectedDestinationPort?.id}
                                >
                                    {destinationPorts && destinationPorts.map((destPort, i) => {
                                        return (
                                            <option key={`destination_port__noStops_${i}_${destPort.countryName}_${destPort.portName}`} value={destPort?.id}>{`${destPort.countryName} - ${destPort.portName}`}</option>
                                        )
                                    })}
                                </Form.Select>
                            </Col>
                        </Row>
                        {
                            canAddDischargePort && (!existingConsignment || !existingConsignment.isPostEOV) ?
                                (
                                    <Col xs={12}>
                                        <Button onClick={(e) => { e.preventDefault(); addStopConsignmentPort(); }} className="mt-3 border-0 btn-secondary cc-add-port-button">
                                            <FontAwesomeIcon icon={faCirclePlus} className="primary-green" /> Add Discharge port
                                        </Button>

                                    </Col>
                                ) : null
                        }
                        <Row className="mt-4">
                            <Col xs={12} className='voluntary-data-bg pt-2 pb-2'>
                                <Row>
                                    <Col xs={12} className="darkblue field-label mb-1">
                                        Estimated departure
                                    </Col>
                                </Row>
                                <Row>
                                    <DateTimePicker
                                        port={selectedDeparturePort}
                                        datetime={estimatedDepartureDateTime}
                                        isValid={isEstimatedDepartureDateTimeValid}
                                        errorMessage={estimatedDepartureErrorMessages.length > 0 ? estimatedDepartureErrorMessages.join("\n") : ""}
                                        onChange={(date) => {
                                            setEstimatedDepartureDateTime(date);
                                        }}
                                        showHeadLabel={true}
                                        endLabel="Local time"
                                        showUTCTime={true}
                                        showTime={true}
                                        backgroundClass="bg-white"
                                    />
                                </Row>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col xs={12} className='voluntary-data-bg pt-2 pb-2'>
                                <Row>
                                    <Col xs={12} className="darkblue field-label mb-1">
                                        Estimated Arrival
                                    </Col>
                                </Row>
                                <Row>
                                    <DateTimePicker
                                        port={selectedDestinationPort}
                                        datetime={estimatedArrivalDateTime}
                                        isValid={isEstimatedArrivalDateTimeValid}
                                        errorMessage={estimatedArrivalErrorMessages.length > 0 ? estimatedArrivalErrorMessages.join("\n") : ""}
                                        onChange={(date) => {
                                            setEstimatedArrivalDateTime(date);
                                        }}
                                        showHeadLabel={true}
                                        endLabel="Local time"
                                        showUTCTime={true}
                                        showTime={true}
                                        backgroundClass="bg-white"
                                    />
                                </Row>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col xs={12} className="darkblue field-label mb-1">
                                Vessel Name
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <Form.Select
                                    onChange={(e) => {
                                        setVesselID(e.target.value);
                                    }}
                                    value={vesselID}
                                >
                                    {vessels && vessels.length > 0 && vessels.map(v => {
                                        return (
                                            <option key={`vessel_${v.vesselName}`} value={v.id}>{v.vesselName}</option>
                                        )
                                    })

                                    }
                                </Form.Select>
                            </Col>
                        </Row>
                        {userCtx.user?.orgTypeID !== UserType.REGULATORY &&
                            <>
                                <Row className="mt-4">
                                    <Col xs={12}>
                                        <div className="heading-text darkblue">Feed plan</div>
                                        <div className="bg-override-primary mt-1 mb-3" style={{ height: "2px" }}></div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12}>
                                        <Row className='mb-1'>
                                            <Col xs={6}></Col>
                                            <Col xs={2} className="text-center field-label">Pellets</Col>
                                            <Col xs={2} className="text-center field-label">Grain</Col>
                                            <Col xs={2} className="text-center field-label">Roughage</Col>
                                        </Row>

                                        <PortStopFeedLoading
                                            uniqueID={`ROBFromPrevious`}
                                            label={`ROB from previous voyage`}
                                            stopData={{
                                                pellets: robPellets,
                                                grain: robGrain,
                                                roughage: robRoughage,
                                                pelletsValid: robPelletsValid,
                                                grainValid: robGrainValid,
                                                roughageValid: robRoughageValid
                                            }}
                                            onChange={(type, value) => updateConsignmentFeedROB(type, value)}
                                        />

                                        {
                                            selectedFeedOnlyLoadPorts?.map((port, index) =>
                                                port.feedLoadedPriorToDeparture === true ? (
                                                    <PortStopFeedLoading
                                                        uniqueID={`feedOnlyPortFeed_${index}`}
                                                        label={`Loading in ${port?.portName} (feed-only)`}
                                                        stopData={port.feedPlan}
                                                        onChange={(type, value) => updateFeedOnlyConsignmentPortFeed(index, type, value)}
                                                    />
                                                ) : null
                                            )
                                        }

                                        <PortStopFeedLoading
                                            uniqueID={`loadingAtDepPort`}
                                            label={`Loading in ${selectedDeparturePort?.portName} (Departure)`}
                                            stopData={{
                                                pellets: departureLoadingPellets,
                                                grain: departureLoadingGrain,
                                                roughage: departureLoadingRoughage,
                                                pelletsValid: loadedPelletsValid,
                                                grainValid: loadedGrainValid,
                                                roughageValid: loadedRoughageValid
                                            }}
                                            onChange={(type, value) => updateConsignmentPortLoadedFeed(type, value)}
                                        />

                                        {
                                            selectedFeedOnlyLoadPorts?.map((port, index) =>
                                                !port.feedLoadedPriorToDeparture ? (
                                                    <PortStopFeedLoading
                                                        uniqueID={`feedOnlyPortFeed_${index}`}
                                                        label={`Loading in ${port?.portName} (feed-only)`}
                                                        stopData={port.feedPlan}
                                                        onChange={(type, value) => updateFeedOnlyConsignmentPortFeed(index, type, value)}
                                                    />
                                                ) : null
                                            )
                                        }
                                    </Col>
                                </Row>
                                <Row className="bg-grey-transparent py-2">
                                    <Col xs={6} className="field-label darkblue" style={{ lineHeight: "27px" }}>Total all feed ({formatUpToSpecifiedPrecision(totalFeed, 2)}t)</Col>
                                    <Col xs={2} className="text-end pe-4" style={{ lineHeight: "27px" }}><span className="secondary-grey" style={{ fontSize: "13px", fontWeight: "400" }}>{formatUpToSpecifiedPrecision(totalPellets, 2)}</span><span className="darkblue" style={{ marginLeft: "4px", fontSize: "12px", fontWeight: "500" }}>t</span></Col>
                                    <Col xs={2} className="text-end pe-4" style={{ lineHeight: "27px" }}><span className="secondary-grey" style={{ fontSize: "13px", fontWeight: "400" }}>{formatUpToSpecifiedPrecision(totalGrain, 2)}</span><span className="darkblue" style={{ marginLeft: "4px", fontSize: "12px", fontWeight: "500" }}>t</span></Col>
                                    <Col xs={2} className="text-end pe-4" style={{ lineHeight: "27px" }}><span className="secondary-grey" style={{ fontSize: "13px", fontWeight: "400" }}>{formatUpToSpecifiedPrecision(totalRoughage, 2)}</span><span className="darkblue" style={{ marginLeft: "4px", fontSize: "12px", fontWeight: "500" }}>t</span></Col>
                                </Row>
                            </>
                        }
                        <Row className="mb-4 mt-5">
                            <Col xs={12} className='voluntary-data-bg p-2'>
                                <Form>
                                    <Form.Check
                                        type={`checkbox`}
                                        id='chkFeedPerDeck'
                                        label={`Require collection of feed per deck information`}
                                        checked={isFeedPerDeckEnabled === true}
                                        onChange={() => setIsFeedPerDeckEnabled(!isFeedPerDeckEnabled)}
                                        className="field-label secondary-grey"
                                    />
                                </Form>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="bg-override-primary mt-1 mb-1" style={{ height: "2px" }}></div>
                            </Col>
                        </Row>
                        <Row className="mb-4 mt-4">
                            <Col xs={12} className='voluntary-data-bg p-2'>
                                <Form>
                                    <Form.Check
                                        type={`checkbox`}
                                        id='chkAlternatingPenSpacing'
                                        label={`This consignment uses alternate pen spacing`}
                                        checked={isUseAlternatePenSpacing === true}
                                        onChange={() => setIsUseAlternatePenSpacing(!isUseAlternatePenSpacing)}
                                        className="field-label secondary-grey"
                                    />
                                </Form>
                            </Col>
                        </Row>
                        <Row className="mb-4 mt-3">
                            <Col xs={12} className='voluntary-data-bg p-2'>
                                <div className='d-flex align-items-center'>
                                    <Form>
                                        <Form.Check
                                            type={`checkbox`}
                                            id='chkMultiPortLoad'
                                            label={`First consignment on a voyage with multiple livestock loading ports`}
                                            checked={isMultiPortLoad === true}
                                            onChange={() => setIsMultiPortLoad(!isMultiPortLoad)}
                                            className="field-label secondary-grey mb-0"
                                        />
                                    </Form>
                                    <FontAwesomeIcon className="info-icon" icon={faInfoCircle} title={"Select for voyages that have multiple consignments where livestock are loaded at separate ports. E.g. On the same voyage cattle are loaded in Portland, with a second consignment loading cattle in Fremantle."}></FontAwesomeIcon>
                                </div>
                            </Col>
                        </Row>
                        {
                            isBusy &&
                            <Row>
                                <Col>
                                    <div className="text-center">
                                        <Spinner className="mx-auto" />
                                    </div>
                                </Col>
                            </Row>
                        }
                        {
                            hasUnexpectedErrorCheckingLNC &&
                            <Row>
                                <Col Alert={12}>
                                    <Alert
                                        variant="danger"
                                    >
                                        An unexpected error occurred.
                                    </Alert>
                                </Col>
                            </Row>
                        }
                    </Container>
                </Row>
                <Container className="button-container">
                    <Row className="w-100 pt-4" style={{ position: "relative", top: "-300px" }}>
                        <Stack direction="horizontal" gap={2}>
                            <Button variant="primary" onClick={goToPersonnel} size="lg" style={{ marginLeft: "-10px", minWidth: "150px" }}>Next</Button>
                            <Button className="ms-2 me-auto" variant="secondary" onClick={goToDashboard} size="lg" style={{ minWidth: "150px" }}>Previous</Button>
                        </Stack>
                    </Row>
                </Container>
            </Container>
        </LoggedInContainer>
    )
};

export default Consignment_VoyageDetails;